var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "toolbarContainerRef",
    staticClass: "toolbar-button-container"
  }, [_vm._l(_vm.props.toolbarButtonList, function (item, index) {
    return [_c('div', {
      key: index,
      ref: "toolbarWrappersRef",
      refInFor: true,
      class: ['toolbar-item-wrapper', index >= _vm.visibleCount ? 'measure-offscreen' : ''],
      attrs: {
        "data-index": index
      }
    }, [item.presetId === _vm.TOOLBAR_BUTTON_TYPE.HUMAN_SERVICE && _vm.shouldRender(item) && !_vm.isInHumanService ? _c('ToolbarButtonHumanService', {
      attrs: {
        "title": item.title,
        "icon": item.icon
      }
    }) : item.presetId === _vm.TOOLBAR_BUTTON_TYPE.SERVICE_RATING && _vm.shouldRender(item) && _vm.isInHumanService ? _c('ToolbarButtonServiceRating', {
      attrs: {
        "title": item.title,
        "icon": item.icon
      }
    }) : item.presetId === _vm.TOOLBAR_BUTTON_TYPE.END_HUMAN_SERVICE && _vm.shouldRender(item) && (item.displayFlag === 1 && _vm.canEndConversation || _vm.isInHumanService) ? _c('ToolbarButtonEndHumanService', {
      attrs: {
        "title": item.title,
        "icon": item.icon
      }
    }) : _vm.shouldRender(item) && !item.presetId ? _c('div', {
      key: index,
      class: ['toolbar-button', _vm.isH5 ? 'toolbar-button-h5' : ''],
      on: {
        "click": function ($event) {
          return _vm.onClick(item, index);
        }
      }
    }, [item.icon ? _c('Icon', {
      staticClass: "toolbar-button-icon",
      attrs: {
        "file": item.icon,
        "width": "14px",
        "height": "14x"
      }
    }) : _vm._e(), _c('div', {
      staticClass: "toolbar-button-text"
    }, [_vm._v(" " + _vm._s(item.title) + " ")])], 1) : _vm._e()], 1)];
  }), _vm.hiddenItems.length > 0 ? _c('div', {
    ref: "toolbarOverflowRef",
    staticClass: "toolbar-button overflow-button",
    on: {
      "click": _vm.togglePopover
    }
  }, [_c('Icon', {
    attrs: {
      "file": _vm.ToolMoreIcon,
      "width": "14px",
      "height": "14px"
    }
  })], 1) : _vm._e(), _c('div', {
    ref: "toolbarPopoverRef",
    class: ['overflow-popover', _vm.showPopover ? 'show-popover' : '']
  }, _vm._l(_vm.hiddenItems, function (item, index) {
    return _c('div', {
      key: item.id || 'hidden-' + index
    }, [item.presetId === _vm.TOOLBAR_BUTTON_TYPE.HUMAN_SERVICE && _vm.shouldRender(item) && !_vm.isInHumanService ? _c('ToolbarButtonHumanService', {
      staticClass: "overflow-popover-item",
      attrs: {
        "title": item.title,
        "icon": item.icon
      },
      on: {
        "closePopover": _vm.closePopover
      }
    }) : item.presetId === _vm.TOOLBAR_BUTTON_TYPE.SERVICE_RATING && _vm.shouldRender(item) && _vm.isInHumanService ? _c('ToolbarButtonServiceRating', {
      staticClass: "overflow-popover-item",
      attrs: {
        "title": item.title,
        "icon": item.icon
      },
      on: {
        "closePopover": _vm.closePopover
      }
    }) : item.presetId === _vm.TOOLBAR_BUTTON_TYPE.END_HUMAN_SERVICE && _vm.shouldRender(item) && (item.displayFlag === 1 && _vm.canEndConversation || _vm.isInHumanService) ? _c('ToolbarButtonEndHumanService', {
      staticClass: "overflow-popover-item",
      attrs: {
        "title": item.title,
        "icon": item.icon
      },
      on: {
        "closePopover": _vm.closePopover
      }
    }) : _vm.shouldRender(item) ? _c('div', {
      staticClass: "overflow-popover-item",
      on: {
        "click": function ($event) {
          return _vm.onClick(item, _vm.visibleCount + index);
        }
      }
    }, [item.icon ? _c('Icon', {
      staticClass: "toolbar-button-icon",
      attrs: {
        "file": item.icon,
        "width": "16px",
        "height": "16px"
      }
    }) : _vm._e(), _c('span', {
      staticClass: "toolbar-button-text",
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(item.title))])], 1) : _vm._e()], 1);
  }), 0), _c('div', {
    ref: "measureOverflowRef",
    staticClass: "measure-offscreen"
  }, [_vm._v("···")])], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }